import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getDirection } from './index';
// Ensure i18n is initialized
import './index';

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = i18n.language;
      document.documentElement.dir = getDirection(i18n.language);
    }
  }, [i18n.language]);

  return <>{children}</>;
}
